export default "__VITE_ASSET__BBiD4x3y__"